import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from 'redux';
import ActionTypes from '../../../../constants/ActionTypes';
import BundleDataFactory from '../../../../factories/manhattan/submit/BundleDataFactory';
import { getSectionFromUrl, getActiveLanguage } from '../../../../utilites/util';
import { setBundleDataAction, setBundleSelectedDataAction } from "./actions";

export const getBundleDataMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);

  if (action.type === ActionTypes.MANHATTAN.BUNDLE_DATA.GET_DATA) {
    const segment = getSectionFromUrl();
    const language = getActiveLanguage();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    const { stbNumber, singleProductType, purchase, options, ...restParams } = params;
    const bundleDataFactory = new BundleDataFactory(action.payload, segment, language, restParams);
    const bundleData = bundleDataFactory.create();
    next(setBundleDataAction(bundleData));
  }
};

export const setBundleDataMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);

  switch (action.type) {
  case ActionTypes.MANHATTAN.BUNDLE_DATA.SET_DATA:
    next(setBundleDataAction(action.payload));
    break;
  case ActionTypes.MANHATTAN.BUNDLE_DATA.SET_SELECTED_PRODUCTS:
    next(setBundleSelectedDataAction(action.payload));
  }
};

export const bundleDataMiddleware = [
  getBundleDataMiddleware,
  setBundleDataMiddleware
];
